import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { UserResponse } from '@models/response';
import { LoginRequest } from '@models/request';

// Services
import { STORAGE_TOKEN } from '@services/storage/constants';
import { saveStringStorage } from '@services/storage/storage';

// Redux
import { saveUserPreferences, userSetCurrent, UserSignIn } from './index';

// Api's
import { authApi, userPreferencesApi } from '../../api';
import { UserPreferencesSaveRequest } from '@/main/models/request/userPreferencesRequest';
import { KeyValue } from '@/main/models/common';
import { UserPreferencesSaveResponse } from '@/main/models/response/userPreferencesResponse';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* userSignInSaga(action: UserSignIn) {
  const { email, password } = action.payload;

  try {
    const request: LoginRequest = {
      username: email,
      password,
      grant_type: 'password'
    };

    const response: AxiosResponse<Result<UserResponse>> = yield call(
      authApi.loginApi,
      request
    );

    if (response.data.result) {
      saveStringStorage(STORAGE_TOKEN, response.data.result.token);
      yield put(userSetCurrent(response.data.result));
    }
  } catch (exception) {
    // Error
  }
}

export function* getUserPreferenceSaga() {
  try {
    const response: AxiosResponse<Result<UserPreferencesSaveResponse>> = yield call(
      userPreferencesApi.getUserPreferences
    );
    let preferences: UserPreferencesSaveRequest | null = null;
    if (response && response.data && response.data.result) {
      preferences = {
        guid: response.data.result.guid,
        isViewCard: response.data.result.isViewCard
      };
    }
    yield put(saveUserPreferences(preferences, false, null));

  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveUserPreferences(null, true, resultError.messagesDataError));
    }
  }
}

